"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneNumber = exports.createClientSubscription = exports.formatPhoneNumberForKlaviyo = exports.shouldShowSignupModal = exports.shouldShowMiniPopup = exports.sendEventNameOnly = exports.getSessionStorageValues = void 0;
var path_to_tag_map_1 = require("./path-to-tag-map");
var getSessionStorageValues = function () {
    var discountCode = sessionStorage.getItem('discount_code');
    return { discountCode: discountCode };
};
exports.getSessionStorageValues = getSessionStorageValues;
// Function for sign up modal and its submission
var sendEventNameOnly = function (eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: eventName,
    });
};
exports.sendEventNameOnly = sendEventNameOnly;
//pages to exclude the email popup on
var containsExcludedURL = function () {
    if (location.href.includes('/pages/trial-offer') ||
        location.href.includes('/collections/email-exclusives') ||
        location.href.includes('/pages/sperm-health') ||
        location.href.includes('/pages/creator-terms-conditions-guidelines') ||
        location.href.includes('/blogs/')) {
        return true;
    }
    return false;
};
var shouldShowMiniPopup = function () {
    if (containsExcludedURL()) {
        return false;
    }
    if (window.localStorage.getItem('completedPopup') !== 'true') {
        return true;
    }
    return false;
};
exports.shouldShowMiniPopup = shouldShowMiniPopup;
/**
 * Return true if the user has not seen the signup modal last 24 hours
 * returns bool
 */
var shouldShowSignupModal = function () {
    var _a, _b;
    if (containsExcludedURL()) {
        return false;
    }
    // Don't show sign up modal for browsers without local storage
    if (typeof Storage === 'undefined') {
        return false;
    }
    // Don't show sign up modal for those who signed up already
    var subscribed = window.localStorage.getItem('emailSmsSubscriber');
    if (subscribed === 'true') {
        return false;
    }
    else if (window.location.search) {
        // Get query string paramters
        var params = new URLSearchParams(window.location.search);
        // Check the utm to determine if the user is email or sms subscriber
        if (((_a = params.get('utm_medium')) === null || _a === void 0 ? void 0 : _a.includes('email')) || ((_b = params.get('utm_medium')) === null || _b === void 0 ? void 0 : _b.includes('sms'))) {
            window.localStorage.setItem('emailSmsSubscriber', 'true');
            return false;
        }
    }
    // Check to see if the popup has already been completed
    if (window.localStorage.getItem('completedPopup')) {
        return false;
    }
    var lastSeen = window.localStorage.getItem('signupModalLastSeen');
    // Get lastSeen value from localStorage
    if (lastSeen === null) {
        return true;
    }
    // Return true if the user hasn't seen the modal last 24 hours
    var lastSeenDate = new Date(lastSeen);
    lastSeenDate.setDate(lastSeenDate.getDate() + 1);
    if (lastSeenDate.getTime() < new Date().getTime()) {
        return true;
    }
    else {
        return false;
    }
};
exports.shouldShowSignupModal = shouldShowSignupModal;
var formatPhoneNumberForKlaviyo = function (number) {
    var formattedPhone = number.replace(/\D/g, '');
    formattedPhone = '+1' + formattedPhone;
    return formattedPhone;
};
exports.formatPhoneNumberForKlaviyo = formatPhoneNumberForKlaviyo;
// Functions for sending user data to klaviyo
// API Doc: https://developers.klaviyo.com/en/reference/create_client_subscription
var createClientSubscription = function (email, listId, source, smsIntroOffer, phone) {
    if (phone) {
        phone = (0, exports.formatPhoneNumberForKlaviyo)(phone);
    }
    var url = new URL(window.location.href);
    var customProperties = {
        properties: __assign(__assign(__assign({}, (smsIntroOffer && smsIntroOffer !== '' && { SMS_intro_offer_test: smsIntroOffer })), (url && { product_line_interest: path_to_tag_map_1.pathToTagMap[url.pathname] || 'other' })), (email && email !== '' && phone && phone !== '' && { email: email })),
    };
    // if email entered
    // email address is subscribed to email list
    // if email and sms entered
    // sms is subscribed to sms list
    // email custom property is added so that one profile is updated
    // this allows for different consent settings for each list
    var options = {
        method: 'POST',
        headers: {
            revision: '2024-07-15',
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            data: {
                type: 'subscription',
                attributes: __assign(__assign({}, (source && { custom_source: source })), { profile: {
                        data: {
                            type: 'profile',
                            attributes: __assign(__assign(__assign({}, (email && email !== '' && !phone && { email: email })), (phone && phone !== '' && { phone_number: phone })), (Object.keys(customProperties.properties).length && customProperties)),
                        },
                    } }),
                relationships: { list: { data: { type: 'list', id: listId } } },
            },
        }),
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=S98vyi', options)
        .then(function (response) {
        if (response.ok) {
            console.log(response);
        }
        else {
            console.error('Klaviyo server error', response);
        }
    })
        .catch(function (err) { return console.error(err); });
};
exports.createClientSubscription = createClientSubscription;
var formatPhoneNumber = function (number) {
    var phoneNumber = number.replace(/[^\d]/g, '');
    if (phoneNumber.length < 3) {
        return phoneNumber;
    }
    if (phoneNumber.length < 6) {
        return "(".concat(phoneNumber.slice(0, 3), ") ").concat(phoneNumber.slice(3));
    }
    return "(".concat(phoneNumber.slice(0, 3), ") ").concat(phoneNumber.slice(3, 6), "-").concat(phoneNumber.slice(6, 10));
};
exports.formatPhoneNumber = formatPhoneNumber;
// (() => {
//   // For giveaway form on https://opositiv.com/pages/giveaway
//   KlaviyoSubscribe.attachToForms('.klaviyo-giveaway-form', {
//     // Function to call on success
//     success: (form) => {
//       if (form[0].getAttribute('data-form') === 'giveaway') {
//         document
//           .querySelectorAll('.moto-sweep__container')
//           .forEach((modalBody) => {
//             modalBody.classList.add('hide');
//           });
//         document
//           .querySelectorAll('.moto-sweep__success')
//           .forEach((modalBody) => {
//             modalBody.classList.remove('hide');
//           });
//       }
//     },
//     extra_properties: {
//       $source: location.pathname,
//     },
//   });
// })();
